import { Component, Input } from "@angular/core";

import { MedLabelModeType } from "../types";
import { STRING } from "../../../constants/string";
import { NgClassType } from "../../../types";

@Component({
  selector: "med-label[name][label]",
  templateUrl: "./med-label.component.html",
  styleUrls: ["./med-label.component.scss"],
})
export class MedLabelComponent {
  @Input() label!: string;
  @Input() name!: string;
  @Input() mode: MedLabelModeType = "";
  @Input() labelClass = "";
  @Input() disabled = false;
  @Input() required = false;
  @Input() active = false;
  @Input() backwards = false;

  get classList(): NgClassType {
    const active = this.active ? "active" : STRING.EMPTY;
    const backwards = this.backwards ? "backwards" : STRING.EMPTY;
    return [this.mode, active, backwards, this.labelClass].join(STRING.SPACE);
  }
}
